<template>
  <div>
    <!-- 头部 -->
    <div class="header">
      <h1 class="page-title">系统中心</h1>
      <div class="pic">
        <div class="img">
          <span class="pic1"></span>
        </div>
        <div class="img">
          <span class="pic2"></span>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <el-card>
      <!-- 更新内容 -->
      <div class="box-card" v-for="o in 4" :key="o">
        <div class="text">
          <div class="t-top">
            <span>系统更新</span>
            <span class="time">2019年8月31日 08:24</span>
          </div>
          <p class="cont">
            系统消息是指网站管理者以信息广播形式向目标用户发布的公开的消息、公告、通知、提示等。具有群发性，高可达性等消息特性。
            目前是通过定义资料系统消息监听事件来处理通知。 示例：监听资料系统通知函数对象，方法都定义在 资料变化触发时机：当自己或好友的资料发生变化时，会收到此类通知。 示例： 监听 资料变化
          </p>
        </div>
        <div class="smallicon">
          <span class="iconitem1" title="标记未读"></span>
          <span class="iconitem2" title="查看"></span>
          <span class="iconitem3" title="删除"></span>
          <!-- 标注 -->
        </div>
      </div>
      <!-- 分页 -->
      <el-pagination background small layout="prev, pager, next" :total="40"></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  created() {
    if(!window.localStorage.getItem('token')){
      this.$router.replace('/login')
      return
    }
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  text-align: center;
}
.header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  .page-title {
    font-size: 24px;
  }
  .pic {
    display: flex;
    .img {
      width: 42px;
      height: 42px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 24px;
      span {
        width: 22px;
        height: 22px;
        display: block;
      }
      .pic1 {
        background: url('../../../assets/new/xinxi.png') no-repeat;
        background-size: 100%;
      }
      .pic2 {
        background: url('../../../assets/new/saochu.png') no-repeat;
        background-size: 100%;
      }
      .pic1:hover {
        background: url('../../../assets/new/selxinxi.png') no-repeat;
        background-size: 100%;
      }
      .pic2:hover {
        background: url('../../../assets/new/selsaochu.png') no-repeat;
        background-size: 100%;
      }
    }
  }
}
.box-card {
  position: relative;
  width: 98%;
  height: 161px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border-left: 8px solid rgb(223, 223, 223);
  margin-bottom: 16px;
  .text {
    padding: 0 32px;
    box-sizing: border-box;
    .t-top {
      display: flex;
      justify-content: space-between;
      span {
        display: block;
        font-size: 16px;
        margin-top: 16px;
        line-height: 26px;
        font-weight: 500;
        color: rgba(89, 89, 89, 1);
      }
      .time {
        font-size: 10px;
        color: rgba(191, 191, 191, 1);
        font-weight: 400;
      }
    }
    p.cont {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: rgba(140, 140, 140, 1);
    }
  }
  .smallicon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 40px;
    position: absolute;
    bottom: 0px;
    span {
      display: block;
      margin-right: 21px;
    }
    .iconitem1 {
      width: 18px;
      height: 18px;
      background: url('../../../assets/new/nosee.png') no-repeat;
      background-size: 100%;
    }
    .iconitem2 {
      width: 19px;
      height: 13px;
      background: url('../../../assets/new/look.png') no-repeat;
      background-size: 100%;
    }
    .iconitem3 {
      width: 15px;
      height: 18px;
      background: url('../../../assets/new/delete.png') no-repeat;
      background-size: 100%;
    }
    .iconitem1:hover {
      background: url('../../../assets/new/selnosee.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
    .iconitem2:hover {
      background: url('../../../assets/new/sellook.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
    .iconitem3:hover {
      background: url('../../../assets/new/seldele.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
  }
}
.box-card:hover {
  box-shadow: 0px 0px 4px #1890ff;
  border-left: 8px solid #1890ff;
}
</style>